







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'FreemiumFilterBadge',
})
export default class FreemiumFilterBadge extends Vue {
	@Prop({
		default: 'sm',
		validator: (value: string): boolean => {
			return ['sm', 'md', 'lg'].includes(value);
		},
	})
	size: string;

	get classNames() {
		return {
			'freemium-filter__badge': true,
			[`freemium-filter__badge--${this.size}`]: this.size,
		};
	}
}
